export const ECO_BLOCK_ICONS = [
  'ILLUSTRATION-CO2_S_Dark',
  'ILLUSTRATION-Mouse_S_Dark',
  'ILLUSTRATION-Rock_M_Dark',
  'ILLUSTRATION-Waterdrop_M_Dark',
]
